import { render, staticRenderFns } from "./DxfDiffOverlay.vue?vue&type=template&id=63a6ca3e"
import script from "./DxfDiffOverlay.vue?vue&type=script&lang=js"
export * from "./DxfDiffOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports